import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { FSEAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import { ISidebarItem } from '@agco-onedigital/ecosystem-lib-web-components/lib/components/Sidebar/types';

import { commonMessages } from 'messages';

import { useCartEnabled } from '../../../utils/hooks/useCartEnabled';
import { useExpertLinkFlagEnabled } from '../../../utils/hooks/useExpertLinkEnabled';
import { ISidebarProps } from './types';

const messages = commonMessages.menu;
const newFeatureMessages = commonMessages.general;

/** Fired by FSE when `SHARED_MODULE_DATA.cartItemCount` changes so the host sidebar can re-render. */
export const WSM_CART_ITEM_COUNT_EVENT = 'wsm-cart-item-count';

export const useBottomItems = ({ newFeatureItems }: Pick<ISidebarProps, 'newFeatureItems'> = {}) => {
  const { formatMessage } = useIntl();
  const isCartEnabled = useCartEnabled();
  const isExpertLinkEnabled = useExpertLinkFlagEnabled();
  const [cartItemCount, setCartItemCount] = useState(() => globalThis.SHARED_MODULE_DATA?.cartItemCount);

  useEffect(() => {
    const onCartCountChange = () => {
      setCartItemCount(globalThis.SHARED_MODULE_DATA?.cartItemCount);
    };

    window.addEventListener(WSM_CART_ITEM_COUNT_EVENT, onCartCountChange);
    return () => {
      window.removeEventListener(WSM_CART_ITEM_COUNT_EVENT, onCartCountChange);
    };
  }, []);

  const CART: ISidebarItem[] = isCartEnabled
    ? [
        {
          label: formatMessage(messages.myCart),
          icon: 'shopping_cart',
          isFilledIcon: true,
          to: FSEAuthRoutes.CART,
          testId: 'sidebar-my-cart',
          ...(cartItemCount && cartItemCount > 0 ? { badgeNumber: cartItemCount } : {}),
        },
      ]
    : [];

  const SUPPORT_ACTIVITY: ISidebarItem[] = isExpertLinkEnabled
    ? [
        {
          label: formatMessage(messages.supportActivity),
          icon: 'forum',
          to: FSEAuthRoutes.SUPPORT_ACTIVITIES,
          testId: 'sidebar-support-activity',
          ...(newFeatureItems?.supportActivity
            ? {
                badgeText: formatMessage(newFeatureMessages.new),
                badgeTooltipText: formatMessage(newFeatureMessages.newFeatureAvailable),
              }
            : {}),
        },
      ]
    : [];

  const items: ISidebarItem[] = [
    ...CART,
    {
      label: formatMessage(messages.dealerLocator),
      icon: 'location_on',
      to: FSEAuthRoutes.DEALER_LOCATOR_MAIN,
      testId: 'sidebar-dealer-locator',
    },
    {
      label: formatMessage(messages.contactUs),
      icon: 'support',
      to: FSEAuthRoutes.CONTACT_US,
      testId: 'sidebar-contact-us',
    },
    ...SUPPORT_ACTIVITY,
  ];

  return items;
};
